import { lookupsApi } from '.';

export interface PostcodeLookupAddress {
  address_id: number
  Line1?: string
  Line2?: string
  Line3?: string
  posttown: string
  postcode: string
}

export interface PostcodeLookupResponse {
  addresses: PostcodeLookupAddress[]
  status: string
  message: string
}

const extendedLookupsApi = lookupsApi.injectEndpoints({
  endpoints: builder => ({
    postcodeLookup: builder.query<PostcodeLookupResponse, string>({
      query: postcode => `/postcode/lookup?query=${postcode}`
    })
  })
});

export const { useLazyPostcodeLookupQuery } = extendedLookupsApi;
